<template>
  <div class="wait">
    <LoaderPage />
  </div>
</template>

<script>
import CompanyService from "@/services/CompanyService";
import UserService from "@/services/UserService";
import store from "@/store";
import LoaderPage from "@/components/Loader/LoaderPage";

export default {
  name: "LoginSuccessView",
  components: { LoaderPage },
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      UserService.getMyProfile()
        .then((user) => {
          store.dispatch("app/setFrontendLanguage", user.active_language);
          store.dispatch("app/setBackendLanguage", user.active_language);
          store.dispatch("auth/setUser", user);

          CompanyService.getMyAvailableCompanies()
            .then((companies) => {
              store.dispatch("auth/setAvailableCompanies", companies);

              this.$router.push(this.$route.query.nextUrl ? this.$route.query.nextUrl : "/home");
            })
            .catch((error) => {
              this.$router.push({ name: "login" });
            });
        })
        .catch((error) => {
          this.$router.push({ name: "login" });
        });
    }
  }
};
</script>
<style>
.wait {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 350px;
}
</style>
